var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters-field-group"},[_c('label',[_vm._v("Пол")]),_c('filters-select',{attrs:{"options":Object.values(_vm.genders),"initialValue":_vm.genders[_vm.filterValue]},on:{"input":_vm.onChangeGender}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }